var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGrid = function SvgIconGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconGrid_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.445 3.556H5.333c-.981 0-1.777.796-1.777 1.777v7.112c0 .981.796 1.777 1.777 1.777h7.112c.981 0 1.777-.796 1.777-1.777V5.333c0-.981-.796-1.777-1.777-1.777ZM26.667 3.556h-7.111c-.982 0-1.778.796-1.778 1.777v7.112c0 .981.796 1.777 1.778 1.777h7.11c.983 0 1.779-.796 1.779-1.777V5.333c0-.981-.796-1.777-1.778-1.777ZM12.445 17.777H5.333c-.981 0-1.777.796-1.777 1.778v7.111c0 .982.796 1.778 1.777 1.778h7.112c.981 0 1.777-.796 1.777-1.778v-7.11c0-.983-.796-1.779-1.777-1.779ZM26.667 17.777h-7.111c-.982 0-1.778.796-1.778 1.778v7.111c0 .982.796 1.778 1.778 1.778h7.11c.983 0 1.779-.796 1.779-1.778v-7.11c0-.983-.796-1.779-1.778-1.779Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconGrid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgIconGrid;